var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGrabberNs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 16,
  viewBox: "0 0 8 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6.5 11 8 12.5 4 16l-4-3.5L1.5 11 4 13.25zM6 9v1H2V9zm0-3v1H2V6zM4 0l4 3.5L6.5 5 4 2.75 1.5 5 0 3.5z"
})));
export default SvgGrabberNs;